export default "__VITE_ASSET__5HbMo6u0__"